import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "20",
  cy: "20",
  r: "20",
  fill: "#F2F2F2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.5334 13.7629H10.7629V26.0668H12.5334V23.636H26.968V26.0668H28.7385V18.6995C28.7385 16.8674 27.2546 15.3834 25.4225 15.3834H18.8655V21.8655H12.5334V13.7629ZM15.6995 16.1937C14.313 16.1937 13.1937 17.313 13.1937 18.6995C13.1937 20.0859 14.313 21.2052 15.6995 21.2052C17.0859 21.2052 18.2052 20.0859 18.2052 18.6995C18.2052 17.313 17.0859 16.1937 15.6995 16.1937ZM20.636 21.8655V17.154H25.4225C26.2724 17.154 26.968 17.8496 26.968 18.6995V21.8655H20.636ZM14.9642 18.6995C14.9642 18.2952 15.2952 17.9642 15.6995 17.9642C16.1037 17.9642 16.4347 18.2952 16.4347 18.6995C16.4347 19.1037 16.1037 19.4347 15.6995 19.4347C15.2952 19.4347 14.9642 19.1037 14.9642 18.6995Z",
  fill: "#184DB4"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };